<template>
<v-form v-model="valid">
	<v-card>
		<v-card-title class="pb-0 px-3">
			<span class="black--text">{{ account.accounting_no }} - {{ account.name }}</span>
			<v-spacer></v-spacer>
			<v-btn
				dark
				class="me-3"
			    color="success-color"
			    :to="{ name: 'statement', params: { id: account.id } }"
			>
				<v-icon class="me-1">mdi-notebook</v-icon>
				{{$t('buttons.account-statement')}}
			</v-btn>
			<bee-btn
				color="editingColor"
				outer-class="me-3"
				@click="editAccount()"
				icon="fa-user-edit"
				:content="$t('AccountInfoCard.edit-account')"
				context="account"
				:action-name="actions.GET"
				:disabled="file_is_locked || isViewer"
			></bee-btn>
			<bee-btn
			    context="account"
			    :action-name="actions.DELETE"
			    :content="$t('AccountInfoCard.delete-account')"
			    icon="fa-trash-alt"
			    color="deletingColor"
				outer-class="me-3"
			    @click="dialogDelete = true"
			    :disabled="file_is_locked"
			></bee-btn>
		</v-card-title>
		<v-col>
			<v-row>
				<v-col cols="12" md="4" class="px-6">
					<h4 class="grey--text mb-4">
						{{$t('AccountInfoCard.account-type.title')}}:
						<span class="black--text">
							{{ 
								account.type ? configs.account_types.map(c=>({...c,
								name:
								c.value == 1 ? $t('AccountInfoCard.account-type.main') :
								c.value == 2 ? $t('AccountInfoCard.account-type.sub') :
								c.name })).find(c=>c.value == account.type).name : ''
							}}
						</span>
					</h4>
					<h4 class="grey--text mb-4">
						{{$t('AccountInfoCard.account-category')}}
						<span class="black--text">{{ account.parent_account_id ? configs.accounts.find(c=>c.id == account.parent_account_id).name : '' }}</span>
					</h4>
					<h4 class="grey--text mb-4">
						{{$t('AccountInfoCard.final-accounts.title')}}:
						<span class="black--text">
							{{ account.final_type? configs.final_account_types.map(c=>({...c,
							name:
							c.value == 1 ? $t('AccountInfoCard.final-accounts.operations') :
							c.value == 2 ? $t('AccountInfoCard.final-accounts.trade') :
							c.value == 3 ? $t('AccountInfoCard.final-accounts.gains-and-losses') :
							c.value == 4 ? $t('AccountInfoCard.final-accounts.budget') :
							c.name })).find(c=>c.value == account.final_type).name : '' }}
						</span>
					</h4>
					<h4 class="grey--text mb-4">
						{{$t('AccountInfoCard.max-credit-amount')}}:
						<span class="black--text">
							{{ account.max_credit_amount ? account.max_credit_amount.amount :'' }}
						</span>
					</h4>
					<h4 class="grey--text mb-4">
						{{$t('AccountInfoCard.max-debit-amount')}}:
						<span class="black--text">
							{{ account.max_debit_amount ? account.max_debit_amount.amount : '' }}
						</span>
					</h4>
					<h4 class="grey--text mb-4">
						{{$t('AccountInfoCard.debt-is-forbidden')}}:
						<span class="black--text">
							{{ account.is_debt_forbidden ? $t('AccountInfoCard.yes') : $t('AccountInfoCard.no')}}
						</span>
					</h4>
				</v-col>
				<v-divider inset vertical class="mb-3"></v-divider>
				<v-col cols="12" md="6" sm="12" class="px-6">
					<h4 class="grey--text mb-4">
						{{$t('AccountInfoCard.contect-info.phone-number')}}:
						<span class="black--text">{{ account.contact_info? account.contact_info.phone_number : ''}}</span>
					</h4>
					<h4 class="grey--text mb-4">
						{{$t('AccountInfoCard.contect-info.mobile-number')}}:
						<span class="black--text">{{ account.contact_info? account.contact_info.mobile_number : ''}}</span>
					</h4>
					<h4 class="grey--text mb-4">
						{{$t('AccountInfoCard.contect-info.email')}}:
						<span class="black--text">{{ account.contact_info? account.contact_info.email : ''}}</span>
					</h4>

					<h4 class="grey--text mb-4">
						{{$t('AccountInfoCard.contect-info.address')}}:
						<span class="black--text">{{ account.contact_info? account.contact_info.address : ''}}</span>
					</h4>
					<h4 class="grey--text mb-4">
						{{$t('AccountInfoCard.notes')}}:
						<span class="black--text">{{ account.notes }}</span>
					</h4>
				</v-col>
			</v-row>
		</v-col>
	</v-card>
	<v-card-text class="px-0 pt-3">
	<v-expansion-panels>
		<v-expansion-panel>
			<v-expansion-panel-header class="px-3">
				{{$t('AccountInfoCard.account-statement')}}
			</v-expansion-panel-header>
			<v-expansion-panel-content class="statement">
				<v-card flat>
					<bee-simple-table
						context="statement"
						:action-name="actions.GET"
						class="pt-0 currencies-balances" :with-color="true" :zebra="false" empty-state="none" :hide-footer="true" 
						:configs="{...configs, currencies: configs.currencies.filter(c=>c.id != configs.financial_file.default_currency_id)}"
						:headers="sum_result_headers"
						:items="[].concat({...Object.values(this.account_statement)[1], sum_difference_equivalent: sum_difference_equivalent, currencies_sum_difference: this.account_statement.sum_currencies_result.currencies_sum_difference})"
						@equivalent-currency-id-changed="changeSumDifferenceEquivalent($event)"
						:showOnlyNumbersPatch="true"
					>
					</bee-simple-table>
					<bee-simple-table 
						context="statement"
						:action-name="actions.GET"
						class="pt-2 currencies-sum" :with-color="true" :zebra="false" empty-state="none" :hide-footer="true"
						:headers="sum_currencies_result_headers"
						:items="[].concat({...Object.values(
							this.account_statement)[2],
							title: $t('AccountInfoCard.breakdown-of-the-total-by-currency')
						})"
						:configs="configs" :showOnlyNumbersPatch="true"
					>
					</bee-simple-table>
					<v-card-actions class="px-0">
						<v-spacer></v-spacer>
						<bee-btn
							:content="$t('AccountInfoCard.account-statement')"
							icon="far fa-share-square fa-rotate-180"
							color="editingColor"
							@click="statementAccount()"
							context="statement" 
							:action-name="actions.GET"
						></bee-btn>
					</v-card-actions>
				</v-card>
			</v-expansion-panel-content>
		</v-expansion-panel>
	</v-expansion-panels>
	</v-card-text>
	<bee-dialog
	    @handler="deleteAccount()"
	    @close="dialogDelete = false"
	    v-model="dialogDelete"
	    :title="$t('AccountInfoCard.delete-the-account')"
	    :message="
			$t('AccountInfoCard.are-you-sure-you-want-to-delete-the-account-$', {accountName: account.name})
		"
	></bee-dialog>
</v-form>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import  store  from "../../../../store/index.js";
import actions from "../../../../permissions/actions-names.js"
export default {
data: () => ({
	actions,
	sum_difference_equivalent: { amount: null, currency_id: null, money_type: null},
	dialogDelete: false,
    valid: false,
    account: {
		accounting_no: null,
		name: null,
		inner_accounting_no: null,
		is_box: null,
		type: null,
		final_type: null,
		max_credit_amount: {
			amount: null,
			currency_id: null
		},
		max_debit_amount: {
			amount: null,
			currency_id: null
		},
		is_debt_forbidden: null,
		notes: null,
		contact_info_id: null,
		parent_account_id: null,
		id: null
    },
	default_account:{
		accounting_no: null,
		name: null,
		inner_accounting_no: null,
		is_box: null,
		type: null,
		final_type: null,
		max_credit_amount: {
			amount: null,
			currency_id: null
		},
		max_debit_amount: {
			amount: null,
			currency_id: null
		},
		is_debt_forbidden: null,
		notes: null,
		contact_info_id: null,
		parent_account_id: null,
		id: null,
	},
	contact_info: {
		id: null,
		mobile_number: null,
		phone_number: null,
		address: null,
		email: null,
		account_id: null
	},
	default_contact_info: {
		id: null,
		mobile_number: null,
		phone_number: null,
		address: null,
		email: null,
		account_id: null
	},
}),
methods: {
    editAccount() {
		this.$router.push({ name: "edit-account", params: { id: this.account.id} });
    },
    createCategory() {
		this.$router.push({ name: "custom-statements" });
    },
    statementAccount() {
		this.$router.push({ name: "statement", params: { id: this.account.id } }).catch(()=>{})
	},
	changeSumDifferenceEquivalent(toCurrencyId) {
		if(toCurrencyId)
		{
			let sum_difference = this.account_statement?.sum_result?.sum_difference
			if(sum_difference?.amount)
			{
				let amount = sum_difference.amount
				let fromCurrecyId = sum_difference.currency_id
				store.dispatch("currencies/exchangeToCurrency",{toCurrencyId, amount, fromCurrecyId})
					.then(response => {
						_.set(this.sum_difference_equivalent,"amount", response.amount)
						_.set(this.sum_difference_equivalent,"currency_id", response.currency_id)
						_.set(this.sum_difference_equivalent,"money_type", sum_difference.money_type)

					})
			}
		}
	},
	deleteAccount(){
		store.dispatch("accounts/delete", {id: this.account.id})
			.then(()=>{
				Promise.all([store.dispatch("configs/fetchAll"),
					store.dispatch("accounts/fetchTree"),
					store.dispatch("customStatements/fetchAll")
				]);
				this.$router.replace({ name: 'accounts-tree' })
				this.reSet() })
	},
	reSet(){
		this.account = {...this.default_account}
		this.contact_info = {...this.default_contact_info}
	}
},
computed:{
	...mapState("configs" , ["configs"]),
	...mapState({ account_statement: state => state.statements.account_statement_summary }),
	...mapGetters({
			isViewer: 'auth/isViewer'
		}),
	
	sum_result_headers() {
		return [
			{ text: '', value: '3', type: '', width: '12%' },
			{
				text: this.$t('AccountInfoCard.headers.sum-debits'),
				value: 'sum_debits',
				type: 'money',
				width: '15%',
				editable: true,
				settings:{ perspective: 'statement'}
			},
			{
				text: this.$t('AccountInfoCard.headers.sum-credits'),
				value: 'sum_credits',
				type: 'money',
				width: '15%',
				editable: true,
				settings:{ perspective: 'statement'}
			},
			{
				text: this.$t('AccountInfoCard.headers.balance'),
				value: 'sum_difference',
				type: 'money',
				width: '15%',
				editable: true,
				settings:{ perspective: 'statement'}
			},
			{
				text: this.$t('AccountInfoCard.headers.equivalent-currency'),
				value: 'sum_difference_equivalent.currency_id',
				type: 'select',
				width: '8%'
			},
			{
				text: this.$t('AccountInfoCard.headers.currency-equivalent'),
				value: 'sum_difference_equivalent',
				type: 'money',
				width: '15%',
				editable: true,
				settings:{ perspective: 'statement'}
			},
			{
				text: this.$t('AccountInfoCard.headers.currencies-balances'),
				value: 'currencies_sum_difference',
				type: 'string',
				width: '15%'
			},
		]
	},
	sum_currencies_result_headers() {
		return [
			{
				text: '',
				value: 'title',
				type: '',
				width: '12%'
			},
			{
				text: this.$t('AccountInfoCard.sum-currencies-result-headers.currency-debits'),
				value: 'currency_debits',
				type: 'string',
				width: '15%',
				editable: true
			},
			{
				text: this.$t('AccountInfoCard.sum-currencies-result-headers.currency-credits'),
				value: 'currency_credits',
				type: 'string',
				width: '15%',
				editable: true
			},
			{ text: '', value: '1', type: '', width: '57%', editable: true },
		]
	},

	file_is_locked(){
        return this.configs?.financial_file?.is_locked }
},
mounted(){
	if(this.$route.params.id) {
		this.account = this.configs.accounts.find(c=>c.id == Number(this.$route.params.id))
		if (this.$route.query.isDelete) {
			this.dialogDelete = true;
		}
	}
},
watch: {
	$route: async function () {
			if(this.$route.params.id)
			{
				this.account = this.configs.accounts.find(c=>c.id == Number(this.$route.params.id))
				this.sum_difference_equivalent = { amount: null, currency_id: null, money_type: null}
				if (this.$route.query.isDelete) {
					this.dialogDelete = true;
				}
				// await store.dispatch("accounts/fetch", { id: this.$route.params.id }).then(response => { this.account = {...response} })
			}			
			// else
			// 	this.reSet()
	}
},
async beforeRouteEnter(to, from, next) {
	if(to.params.id) 
		await store.dispatch("statements/fetchAccountStatementSummary", { accountId: to.params.id })
    next()
	// next(vm => {
	// 	if(to.params.id) 
	// 	{	
	// 		store.dispatch("accounts/fetch", { id: to.params.id }).then(response => { vm.account = {...response} })
	// 	}
	// })
}
};
</script>
<style scoped>
.medium-placeholder .v-label {
	font-size: 0.7rem !important;
}
.my-border {
    border:1px solid !important;
}
</style>
<style>
.statement .v-expansion-panel-content__wrap {
    padding: 0 12px 0px;
    flex: 1 1 auto;
    max-width: 100%;
}
.currencies-balances tr>td:nth-child(7) {
    direction: ltr;
}
</style>